import { C } from "../../shared/theme";
import { PhaseBadge } from "./PhaseBadge";

// "Add to today" on a task, or "In Morning" once it is planned. onAdd(task) puts it in today. Every list of
// unfinished tasks uses it (Craig, 23 Oct 2026: "Everywhere there is a task in a list"), so a task reads the
// same everywhere.
export function AddToTodayButton({ task, onAdd, style }) {
  if (task.todayPhase) return <PhaseBadge phaseId={task.todayPhase} style={{ flexShrink: 0, ...style }} />;
  return (
    <button onClick={() => onAdd(task)} aria-label={`Add "${task.text}" to today`}
      style={{ flexShrink: 0, minHeight: 44, padding: "0 10px", border: "none", background: "none", color: C.textGreen, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", ...style }}>
      Add to today
    </button>
  );
}
